import { FC } from 'react';

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from '@/components/ui/Form';
import RadioGroup, { RadioItem } from '@/components/ui/RadioGroup';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const INSURER_DECISION = {
  POSITIVE: 'positive',
  NEGATIVE: 'negative',
  NO_DECISION: 'no_decision',
} as const;

export const INSURER_DECISION_NAME = 'insurer_decision';

interface Props {
  name?: string;
  isComplementary?: boolean;
}

export const RadioGroupIssuerDecision: FC<Props> = ({
  name = INSURER_DECISION_NAME,
}) => {
  const { i18n } = useLingui();
  const { control } = useFormContext();

  return (
    <FormField
      control={control}
      name={name}
      rules={{
        required: {
          value: true,
          message: i18n.t('Uzupełnij to pole, aby przejść dalej'),
        },
      }}
      render={({ field }) => (
        <FormItem>
          <FormLabel>{i18n.t('Jaką decyzję wydał ubezpieczyciel?')}</FormLabel>
          <FormControl>
            <RadioGroup {...field} layout={'vertical'}>
              <RadioItem
                data-testid={`${name}-radio-group-${INSURER_DECISION.POSITIVE}`}
                value={INSURER_DECISION.POSITIVE}
                label={i18n.t('Podjął się likwidacji szkody')}
              />
              <RadioItem
                data-testid={`${name}-radio-group-${INSURER_DECISION.NEGATIVE}`}
                value={INSURER_DECISION.NEGATIVE}
                label={i18n.t('Odmówił likwidacji szkody')}
              />
              <RadioItem
                data-testid={`${name}-radio-group-${INSURER_DECISION.NO_DECISION}`}
                value={INSURER_DECISION.NO_DECISION}
                label={i18n.t('Brak decyzji')}
              />
            </RadioGroup>
          </FormControl>
        </FormItem>
      )}
    />
  );
};
